<template>
  <header>
    <nav class="flex flex-wrap items-center justify-between w-full px-2 py-8">
      <div class="container flex flex-wrap items-baseline justify-between px-4 mx-auto">
        <div class="relative flex justify-between w-full lg:w-auto lg:static lg:block lg:justify-start">

          <a
            href="/"
            class="text-2xl"
          >
            HyperDbg Debugger
          </a>

          <button
            class="block py-1 border border-transparent outline-none cursor-pointer lg:hidden focus:outline-none"
            type="button"
            v-on:click="toggleNavbar()"
          >
            <svg aria-hidden="true" data-prefix="fas" data-icon="bars" class="svg-inline--fa fa-bars fa-w-14" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" v-bind:svg-inline="''" v-if="!showMenu" v-bind:class="'inline-block w-6 h-6 text-gray-900 border-none fill-current focus:outline-none'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path fill="currentColor" d="M16 132h416c8.837 0 16-7.163 16-16V76c0-8.837-7.163-16-16-16H16C7.163 60 0 67.163 0 76v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16z"/></svg>

            <svg aria-hidden="true" data-prefix="fas" data-icon="times" class="svg-inline--fa fa-times fa-w-11" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 352 512" v-else="" v-bind:svg-inline="''" v-bind:class="'inline-block w-6 h-6 text-gray-900 border-none fill-current focus:outline-none'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path fill="currentColor" d="M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48 0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28 12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48 0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z"/></svg>
          </button>
        </div>

        <div
          class="items-center flex-grow lg:flex"
          :class="{'hidden': !showMenu, 'block': showMenu}"
        >
          <ul class="flex flex-col mt-6 list-none lg:ml-16 lg:mt-0 lg:flex-row">
            <li class="flex items-center">
              <a
                class="flex items-center py-4 text-gray-800 lg:px-3 lg:py-2"
                href="https://docs.hyperdbg.org/"
              >Documentation</a>
            </li>

            <li class="flex items-center">
              <a
                class="flex items-center py-4 text-gray-800 lg:px-3 lg:py-2"
                href="https://doxygen.hyperdbg.org/"
              >Doxygen</a>
            </li>

            <li class="flex items-center">
              <div class="relative">
                <button
                  class="flex items-center py-4 text-gray-800 lg:px-3 lg:py-2 focus:outline-none"
                  @click="showTutorials = ! showTutorials"
                >Hypervisor Tutorial
                  <svg
                    class="w-5 h-5 ml-2 -mr-1"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                      clip-rule="evenodd"
                    />
                  </svg>
                </button>

                <div
                  class="left-0 z-50 w-56 origin-top-right rounded-md lg:mt-2 lg:shadow-lg lg:absolute lg:ml-3"
                  v-show="showTutorials"
                >
                  <div
                    class="bg-white rounded-md lg:border lg:shadow-sm"
                    role="menu"
                    aria-orientation="vertical"
                    aria-labelledby="options-menu"
                  >
                    <div class="py-1">
                      <a
                        :key="index"
                        v-for="(item, index) in tutorials"
                        :href="item.link"
                        class="block px-4 py-2 text-sm leading-5 text-gray-700 hover:bg-gray-100 hover:text-gray-900 focus:outline-none focus:bg-gray-100 focus:text-gray-900"
                        role="menuitem"
                        v-text="item.title"
                      ></a>
                    </div>
                  </div>
                </div>

              </div>
            </li>

            <li class="flex items-center">
              <a
                class="flex items-center py-4 text-gray-800 lg:px-3 lg:py-2"
                href="https://rayanfam.com/"
              >Blog</a>
            </li>
          </ul>

          <div class="flex flex-col sm:flex-row sm:items-center sm:justify-between list-none lg:justify-end lg:ml-auto">
            <ul class="flex list-none">
              <li class="flex items-center">
                <a
                  class="flex items-center py-4 pr-3 text-gray-800 lg:px-3 lg:py-2"
                  href="https://twitter.com/HyperDbg"
                >
                  <svg aria-hidden="true" data-prefix="fab" data-icon="twitter" class="svg-inline--fa fa-twitter fa-w-16" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" v-bind:svg-inline="''" v-bind:class="'inline-block w-6 h-6 text-gray-700 fill-current hover:text-red-500'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path fill="currentColor" d="M459.37 151.716c.325 4.548.325 9.097.325 13.645 0 138.72-105.583 298.558-298.558 298.558-59.452 0-114.68-17.219-161.137-47.106 8.447.974 16.568 1.299 25.34 1.299 49.055 0 94.213-16.568 130.274-44.832-46.132-.975-84.792-31.188-98.112-72.772 6.498.974 12.995 1.624 19.818 1.624 9.421 0 18.843-1.3 27.614-3.573-48.081-9.747-84.143-51.98-84.143-102.985v-1.299c13.969 7.797 30.214 12.67 47.431 13.319-28.264-18.843-46.781-51.005-46.781-87.391 0-19.492 5.197-37.36 14.294-52.954 51.655 63.675 129.3 105.258 216.365 109.807-1.624-7.797-2.599-15.918-2.599-24.04 0-57.828 46.782-104.934 104.934-104.934 30.213 0 57.502 12.67 76.67 33.137 23.715-4.548 46.456-13.32 66.599-25.34-7.798 24.366-24.366 44.833-46.132 57.827 21.117-2.273 41.584-8.122 60.426-16.243-14.292 20.791-32.161 39.308-52.628 54.253z"/></svg>
                </a>
              </li>

              <li class="flex items-center">
                <a
                  class="flex items-center py-4 text-gray-800 lg:px-3 lg:py-2"
                  href="https://github.com/HyperDbg"
                >
                  <svg aria-hidden="true" data-prefix="fab" data-icon="github" class="svg-inline--fa fa-github fa-w-16" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 496 512" v-bind:svg-inline="''" v-bind:class="'inline-block w-6 h-6 text-gray-700 fill-current hover:text-red-500'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path fill="currentColor" d="M165.9 397.4c0 2-2.3 3.6-5.2 3.6-3.3.3-5.6-1.3-5.6-3.6 0-2 2.3-3.6 5.2-3.6 3-.3 5.6 1.3 5.6 3.6zm-31.1-4.5c-.7 2 1.3 4.3 4.3 4.9 2.6 1 5.6 0 6.2-2s-1.3-4.3-4.3-5.2c-2.6-.7-5.5.3-6.2 2.3zm44.2-1.7c-2.9.7-4.9 2.6-4.6 4.9.3 2 2.9 3.3 5.9 2.6 2.9-.7 4.9-2.6 4.6-4.6-.3-1.9-3-3.2-5.9-2.9zM244.8 8C106.1 8 0 113.3 0 252c0 110.9 69.8 205.8 169.5 239.2 12.8 2.3 17.3-5.6 17.3-12.1 0-6.2-.3-40.4-.3-61.4 0 0-70 15-84.7-29.8 0 0-11.4-29.1-27.8-36.6 0 0-22.9-15.7 1.6-15.4 0 0 24.9 2 38.6 25.8 21.9 38.6 58.6 27.5 72.9 20.9 2.3-16 8.8-27.1 16-33.7-55.9-6.2-112.3-14.3-112.3-110.5 0-27.5 7.6-41.3 23.6-58.9-2.6-6.5-11.1-33.3 2.6-67.9 20.9-6.5 69 27 69 27 20-5.6 41.5-8.5 62.8-8.5s42.8 2.9 62.8 8.5c0 0 48.1-33.6 69-27 13.7 34.7 5.2 61.4 2.6 67.9 16 17.7 25.8 31.5 25.8 58.9 0 96.5-58.9 104.2-114.8 110.5 9.2 7.9 17 22.9 17 46.4 0 33.7-.3 75.4-.3 83.6 0 6.5 4.6 14.4 17.3 12.1C428.2 457.8 496 362.9 496 252 496 113.3 383.5 8 244.8 8zM97.2 352.9c-1.3 1-1 3.3.7 5.2 1.6 1.6 3.9 2.3 5.2 1 1.3-1 1-3.3-.7-5.2-1.6-1.6-3.9-2.3-5.2-1zm-10.8-8.1c-.7 1.3.3 2.9 2.3 3.9 1.6 1 3.6.7 4.3-.7.7-1.3-.3-2.9-2.3-3.9-2-.6-3.6-.3-4.3.7zm32.4 35.6c-1.6 1.3-1 4.3 1.3 6.2 2.3 2.3 5.2 2.6 6.5 1 1.3-1.3.7-4.3-1.3-6.2-2.2-2.3-5.2-2.6-6.5-1zm-11.4-14.7c-1.6 1-1.6 3.6 0 5.9 1.6 2.3 4.3 3.3 5.6 2.3 1.6-1.3 1.6-3.9 0-6.2-1.4-2.3-4-3.3-5.6-2z"/></svg>
                </a>
              </li>
            </ul>

            <ul class="flex list-none sm:my-4 lg:ml-3">
              <li class="flex items-center">
                <a
                  href="/download"
                  class="flex items-center px-4 py-2 text-sm font-bold text-white uppercase bg-red-500 rounded shadow outline-none active:bg-gray-100 hover:shadow-md focus:outline-none hover:bg-red-600 hover:shadow-lg"
                >
                  <svg aria-hidden="true" data-prefix="fas" data-icon="download" class="svg-inline--fa fa-download fa-w-16" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" v-bind:svg-inline="''" v-bind:class="'inline-block w-3 h-3 mr-2 text-white fill-current'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path fill="currentColor" d="M216 0h80c13.3 0 24 10.7 24 24v168h87.7c17.8 0 26.7 21.5 14.1 34.1L269.7 378.3c-7.5 7.5-19.8 7.5-27.3 0L90.1 226.1c-12.6-12.6-3.7-34.1 14.1-34.1H192V24c0-13.3 10.7-24 24-24zm296 376v112c0 13.3-10.7 24-24 24H24c-13.3 0-24-10.7-24-24V376c0-13.3 10.7-24 24-24h146.7l49 49c20.1 20.1 52.5 20.1 72.6 0l49-49H488c13.3 0 24 10.7 24 24zm-124 88c0-11-9-20-20-20s-20 9-20 20 9 20 20 20 20-9 20-20zm64 0c0-11-9-20-20-20s-20 9-20 20 9 20 20 20 20-9 20-20z"/></svg>
                  <span>Download</span>
                </a>
              </li>

              <li class="flex items-center">
                <a
                  href="https://github.com/HyperDbg/HyperDbg#publications"
                  class="flex items-center px-4 py-2 ml-3 text-sm font-bold text-white uppercase bg-indigo-500 rounded shadow outline-none active:bg-gray-100 hover:shadow-md focus:outline-none hover:bg-indigo-600 hover:shadow-lg"
                >
                  <svg aria-hidden="true" data-prefix="fas" data-icon="quote-right" class="svg-inline--fa fa-quote-right fa-w-16" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" v-bind:svg-inline="''" v-bind:class="'inline-block w-3 h-3 mr-2 fill-current'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path fill="currentColor" d="M464 32H336c-26.5 0-48 21.5-48 48v128c0 26.5 21.5 48 48 48h80v64c0 35.3-28.7 64-64 64h-8c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h8c88.4 0 160-71.6 160-160V80c0-26.5-21.5-48-48-48zm-288 0H48C21.5 32 0 53.5 0 80v128c0 26.5 21.5 48 48 48h80v64c0 35.3-28.7 64-64 64h-8c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h8c88.4 0 160-71.6 160-160V80c0-26.5-21.5-48-48-48z"/></svg>
                  <span>Cite Paper</span>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </nav>
  </header>
</template>

<script>

export default {
  components: {
  },

  data () {
    return {
      showMenu: false,

      showTutorials: false,
      tutorials: [
        { title: 'Part 1', link: 'https://rayanfam.com/topics/hypervisor-from-scratch-part-1/' },
        { title: 'Part 2', link: 'https://rayanfam.com/topics/hypervisor-from-scratch-part-2/' },
        { title: 'Part 3', link: 'https://rayanfam.com/topics/hypervisor-from-scratch-part-3/' },
        { title: 'Part 4', link: 'https://rayanfam.com/topics/hypervisor-from-scratch-part-4/' },
        { title: 'Part 5', link: 'https://rayanfam.com/topics/hypervisor-from-scratch-part-5/' },
        { title: 'Part 6', link: 'https://rayanfam.com/topics/hypervisor-from-scratch-part-6/' },
        { title: 'Part 7', link: 'https://rayanfam.com/topics/hypervisor-from-scratch-part-7/' },
        { title: 'Part 8', link: 'https://rayanfam.com/topics/hypervisor-from-scratch-part-8/' }
      ]
    }
  },

  methods: {
    toggleNavbar: function () {
      this.showMenu = !this.showMenu
    }
  }
}
</script>
